module.exports = __webpack_public_path__ + "img/COD.43a679cb.svg";